import React from 'react';
import { Row, Col, Typography, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Search } = Input;

type Props = {
  searchTerm: string,
  onChangeSearch: (value: string) => void,
  onSubmitSearch: () => void,
}

export default class Header extends React.PureComponent<Props> {
  render() {
    const {
      searchTerm,
      onChangeSearch,
      onSubmitSearch,
    } = this.props;

    return (
      <Row gutter={16} style={{ marginBottom: '24px' }}>
        <Col span={12}>
          <Title level={2} style={{ margin: 0 }}>
            Tool Box Talk Signing
          </Title>
          <p style={{ color: '#666', marginTop: '8px' }}>
            Review and sign your pending Tool Box Talk documents
          </p>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Search
            placeholder="Search TBT documents..."
            value={searchTerm}
            onChange={(e) => onChangeSearch(e.target.value)}
            onSearch={onSubmitSearch}
            style={{ width: 300 }}
            enterButton={<SearchOutlined />}
          />
        </Col>
      </Row>
    );
  }
}
